import React, { Key, useEffect, useState } from 'react'
import './PersonalInfo.scss'
import profileService from 'Services/profileService'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import state from 'Data/stateNG.json'
import { EmployeeSingleType } from '@/Models/employeeType'

const relationships = [
  'Father',
  'Mother',
  'Brother',
  'Sister',
  'Spouse',
  'Partner',
  'Uncle',
  'Aunt',
  'Cousin',
  'Friend',
  'Children',
  'Guardian',
  'Other',
]

type formType = {
  firstName: string
  lastName: string
  middleName: string
  msisdn: string
  emailAddress: string
  personalEmailAddress: string
  isEnabled: boolean
  address: string | null
  state: string | null
  gender: string | null
  maritalStatus: string | null
  dateOfBirth: string | null
  stateOfOrigin: string | null
  jobTitle: string | null
  department: string | null
  employmentType: string | null
  manager: string | null
  employeeId: string | null
  workLocation: string | null
  employmentDate: string | null
  terminationDate: string | null
  deactivationDate: string | null
  salaryEarningCategory?: string | null
  salaryEarningAmount?: number | null
  salaryDeductionsCategory?: string | null
  salaryDeductionsAmount?: number | null

  nextOfKins: {
    fullName: string
    relationship: string
    phoneNumber: string
    emailAddress: string
    address: string
  }
  // otherRelationship: string | null

  emergencyContact: {
    fullName: string
    relationship: string
    phoneNumber: string
    emailAddress: string
    address: string
  }

  workExperience: {
    companyName: string
    role: string
    duration: {
      startYear: string
      endYear: string
    }
    companyContactName: string
    officialEmail: string
    officialPhoneNumber: string
  }[]

  dependents: {
    fullName: string
    relationship: string
    dateOfBirth: string
    phoneNumber: string
    email: string
  }[]
  educationHistory: {
    institutionName: string
    certificateEarned: string
    yearOfGraduation: string
    location: string
  }[]
  nyscDetails: {
    hasCompletedNYSC: true
    certificateNumber: string
    placeOfPrimaryAssignment: string
    institutionAddress: string
    yearOfService: string
  }
  characterReferences: {
    fullName: string
    occupation: string
    phoneNumber: string
    emailAddress: string
    address: string
  }[]
}

type Props = {
  profile: EmployeeSingleType | null | undefined
  setProfile: any
}

const PersonalInfoUser = ({ profile }: Props) => {
  // console.log('r', profile)

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<formType>({
    defaultValues: {
      firstName: profile?.firstName,
      middleName: profile?.middleName,
      lastName: profile?.lastName,
      msisdn: profile?.msisdn,
      emailAddress: profile?.emailAddress,
      personalEmailAddress: profile?.personalEmailAddress,
      isEnabled: profile?.isEnabled,
      address: profile?.address,
      state: profile?.state,
      gender: profile?.gender,
      maritalStatus: profile?.maritalStatus,
      dateOfBirth: profile?.dateOfBirth,
      stateOfOrigin: profile?.stateOfOrigin,

      nextOfKins: {
        fullName: profile?.nextOfKins?.fullName || '',
        relationship: profile?.nextOfKins?.relationship || '',
        phoneNumber: profile?.nextOfKins?.phoneNumber || '',
        emailAddress: profile?.nextOfKins?.emailAddress || '',
        address: profile?.nextOfKins?.address || '',
      },
      // otherRelationship: 'nil',

      emergencyContact: {
        fullName: profile?.emergencyContact?.fullName || '',
        relationship: profile?.emergencyContact?.relationship || '',
        phoneNumber: profile?.emergencyContact?.phoneNumber || '',
        emailAddress: profile?.emergencyContact?.emailAddress || '',
        address: profile?.emergencyContact?.address || '',
      },
      // otherEmergencyContactRelationship: 'nil',

      workLocation: profile?.workLocation,
      employmentDate: profile?.employmentDate,
      terminationDate: profile?.terminationDate,
      deactivationDate: profile?.deactivationDate,
    },
  })

  // Update form values when the profile data changes
  useEffect(() => {
    if (profile) {
      setValue('firstName', profile?.firstName)
      setValue('middleName', profile?.middleName)
      setValue('lastName', profile?.lastName)
      setValue('msisdn', profile?.msisdn)
      setValue('emailAddress', profile?.emailAddress)
      setValue('personalEmailAddress', profile?.personalEmailAddress)
      setValue('isEnabled', profile?.isEnabled)
      setValue('address', profile?.address)
      setValue('state', profile?.state)
      setValue('gender', profile?.gender)
      setValue('maritalStatus', profile?.maritalStatus)
      setValue('dateOfBirth', profile?.dateOfBirth)
      setValue('stateOfOrigin', profile?.stateOfOrigin)

      setValue('nextOfKins.fullName', profile?.nextOfKins?.fullName)
      setValue('nextOfKins.relationship', profile?.nextOfKins?.relationship)
      setValue('nextOfKins.phoneNumber', profile?.nextOfKins?.phoneNumber)
      setValue('nextOfKins.emailAddress', profile?.nextOfKins?.emailAddress)
      setValue('nextOfKins.address', profile?.nextOfKins?.address)

      setValue('emergencyContact.fullName', profile?.emergencyContact?.fullName)
      setValue('emergencyContact.relationship', profile?.emergencyContact?.relationship)
      setValue('emergencyContact.phoneNumber', profile?.emergencyContact?.phoneNumber)
      setValue('emergencyContact.emailAddress', profile?.emergencyContact?.emailAddress)
      setValue('emergencyContact.address', profile?.emergencyContact?.address)
    }
  }, [profile, setValue])

  const [request2, setRequest2] = useState(false)

  const submit = handleSubmit(async (data: formType, e?: React.BaseSyntheticEvent) => {
    e?.preventDefault()
    setRequest2(true)
    await profileService
      .updateProfileV2({
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        msisdn: data.msisdn,
        personalEmailAddress: data.personalEmailAddress,
        address: data.address,
        state: data.state ?? '',
        gender: data.gender,
        maritalStatus: data.maritalStatus,
        dateOfBirth: data.dateOfBirth,
        stateOfOrigin: data.stateOfOrigin,
        nextOfKins: data.nextOfKins,
        emergencyContact: data.emergencyContact,

        // jobTitle: data.jobTitle,
        // department: data.department,
        // employmentType: data.employmentType,
      })
      .then(
        () => {
          setRequest2(false)
          Swal.fire({
            text: 'Personal information update request sent succesfully',
            icon: 'success',
            confirmButtonText: 'Ok',
          })
        },
        (error: { response: { data: { error: string } } }) => {
          console.log(error)
          setRequest2(false)
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          })

          swalWithBootstrapButtons.fire({
            title: 'Oops!',
            text: error.response.data.error,
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'close',
            reverseButtons: true,
          })
        },
      )
    // Here, you would call an API to submit the updated profile data.
  })

  // const selectedRelationship = watch('nextOfKins.relationship')
  // const selectedEmergencyContactRelationship = watch('emergencyContact.relationship')

  // useEffect(() => {
  //   if (selectedRelationship !== 'Other' || selectedEmergencyContactRelationship !== 'Other') {
  //     setValue('otherRelationship', '')
  //     // setValue('otherEmergencyContactRelationship', '')
  //   }
  // }, [selectedRelationship, selectedEmergencyContactRelationship])

  return (
    <div className='personal-info'>
      {/* {loading === true && (
          <tr>
            <td colSpan={5} className='text-center'>
              <HorizontalLoader></HorizontalLoader>
            </td>
          </tr>
        )} */}

      <form onSubmit={submit}>
        <div className='headings'>Basic Details</div>
        <div className='container m-0 p-0'>
          <div className='row'>
            <div className='col-md-6 mt-3'>
              {/* First Name */}
              <label>First Name</label>
              <input
                type='text'
                className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                {...register('firstName', {
                  required: 'First name is required',
                })}
              />
              {errors.firstName && (
                <div className='invalid-feedback'>{errors.firstName.message}</div>
              )}
            </div>
            <div className='col-md-6 mt-3'>
              {/* First Name */}
              <label>Middle Name</label>
              <input
                type='text'
                className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                {...register('middleName', {
                  required: 'Middlename is required',
                })}
              />
              {errors.firstName && (
                <div className='invalid-feedback'>{errors.firstName.message}</div>
              )}
            </div>
            {/* Last Name */}
            <div className='col-md-6 mt-3'>
              <label>Last Name</label>
              <input
                type='text'
                className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                {...register('lastName', {
                  required: 'Last name is required',
                })}
              />
              {errors.lastName && <div className='invalid-feedback'>{errors.lastName.message}</div>}
            </div>
            {/* Gender */}
            <div className='form-group col-12 col-md-6 mt-3'>
              <label htmlFor='gender'>Gender</label>
              <select
                autoComplete='off'
                id='gender'
                className={`form-control ${errors.gender ? 'is-invalid' : ''}`}
                {...register('gender', { required: 'Gender is required' })}
              >
                <option value={''}>select</option>
                <option>M</option>
                <option>F</option>
              </select>
              {errors.gender && <div className='invalid-feedback'>{errors.gender.message}</div>}
            </div>
            <div className='col-md-6 mt-3'>
              <label htmlFor='dateOfBirth'>Date of birth</label>
              <input
                type='date'
                id='dateOfBirth'
                className={`form-control ${errors.dateOfBirth ? 'is-invalid' : ''}`}
                {...register('dateOfBirth', {
                  required: 'field is required',
                })}
              />
              {errors.dateOfBirth && (
                <div className='invalid-feedback'>{errors.dateOfBirth.message}</div>
              )}
            </div>
            {/* Marital status */}
            <div className='form-group col-12 col-md-6 mt-3'>
              <label htmlFor='maritalStatus'>Marital Status</label>
              <select
                autoComplete='off'
                id='maritalStatus'
                className={`form-control ${errors.maritalStatus ? 'is-invalid' : ''}`}
                {...register('maritalStatus', {
                  required: 'field is required',
                })}
              >
                <option value={''}>select</option>
                <option>Married</option>
                <option>Single</option>
              </select>
              {errors.maritalStatus && (
                <div className='invalid-feedback'>{errors.maritalStatus.message}</div>
              )}
            </div>
            <div className='col-md-6 mt-3'>
              <label htmlFor='stateOfOrigin'>State of Origin</label>
              <select
                id='stateOfOrigin'
                className={`form-control ${errors.state ? 'is-invalid' : ''}`}
                {...register('stateOfOrigin', {
                  required: 'field is required',
                })}
              >
                <option value=''>select location</option>
                {state.map((state: { name: string }, index: Key) => {
                  return <option key={index}>{state.name}</option>
                })}
              </select>
              {errors.stateOfOrigin && (
                <div className='invalid-feedback'>{errors.stateOfOrigin.message}</div>
              )}
            </div>
            <div className='headings mt-4'>Contact Information</div>
            {/* p.Email */}
            <div className='col-md-6 mt-3'>
              <label>Personal Email Address</label>
              <input
                type='email'
                className={`form-control ${errors.emailAddress ? 'is-invalid' : ''}`}
                {...register('personalEmailAddress', {
                  required: 'Email is required',
                })}
              />
              {errors.personalEmailAddress && (
                <div className='invalid-feedback'>{errors.personalEmailAddress.message}</div>
              )}
            </div>
            {/* Email */}
            <div className='col-md-6 mt-3'>
              <label>Work Email Address</label>
              <input
                type='email'
                disabled
                className={`form-control ${errors.emailAddress ? 'is-invalid' : ''}`}
                {...register('emailAddress', {
                  required: 'Email is required',
                })}
              />
              {errors.emailAddress && (
                <div className='invalid-feedback'>{errors.emailAddress.message}</div>
              )}
            </div>
            {/* Phone */}
            <div className='col-md-6 mt-3'>
              <label>Phone Number</label>
              <input
                type='text'
                className={`form-control ${errors.msisdn ? 'is-invalid' : ''}`}
                {...register('msisdn', {
                  required: 'Phone number is required',
                })}
              />
              {errors.msisdn && <div className='invalid-feedback'>{errors.msisdn.message}</div>}
            </div>
            {/* Address */}
            <div className='col-md-6 mt-3'>
              <label>Address</label>
              <input
                type='text'
                className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                {...register('address', {
                  required: 'Address is required',
                })}
              />
              {errors.address && <div className='invalid-feedback'>{errors.address.message}</div>}
            </div>
            <div className='headings mt-4'>Next of Kin</div>
            <div className='col-md-6 mt-3'>
              <label>Full Name</label>
              <input
                type='text'
                className={`form-control ${errors.nextOfKins?.fullName ? 'is-invalid' : ''}`}
                {...register('nextOfKins.fullName', {
                  required: 'First name is required',
                })}
              />
              {errors.nextOfKins?.fullName && (
                <div className='invalid-feedback'>{errors.nextOfKins?.fullName.message}</div>
              )}
            </div>
            <div className='col-md-6 mt-3'>
              <label htmlFor='nextOfKinRelationship'>Relationship</label>

              <select
                id='nextOfKinRelationship'
                className={`form-control ${errors.nextOfKins?.relationship ? 'is-invalid' : ''}`}
                {...register('nextOfKins.relationship', {
                  required: 'Next of kin relationship is required',
                })}
              >
                <option value=''>Select relationship</option>

                {relationships.map((rel) => (
                  <option key={rel} value={rel}>
                    {rel}
                  </option>
                ))}
              </select>

              {errors.nextOfKins?.relationship && (
                <div className='invalid-feedback'>{errors.nextOfKins?.relationship.message}</div>
              )}
            </div>
            {/* {selectedRelationship === 'Other' && (
              <div className='col-md-6 mt-3'>
                <label htmlFor='otherRelationship'>Specify Relationship</label>

                <input
                  type='text'
                  id='otherRelationship'
                  className={`form-control ${errors.otherRelationship ? 'is-invalid' : ''}`}
                  {...register('otherRelationship', {
                    required: 'Please specify the relationship',
                  })}
                />

                {errors.otherRelationship && (
                  <div className='invalid-feedback'>{errors.otherRelationship.message}</div>
                )}
              </div>
            )} */}
            {/* Phone */}
            <div className='col-md-6 mt-3'>
              <label htmlFor='nextOfKinPhoneNumber'>Phone Number</label>
              <input
                type='text'
                id='nextOfKinPhoneNumber'
                className={`form-control ${errors.nextOfKins?.phoneNumber ? 'is-invalid' : ''}`}
                {...register('nextOfKins.phoneNumber', {
                  required: 'next of kin phone number is required',
                })}
              />
              {errors.nextOfKins?.phoneNumber && (
                <div className='invalid-feedback'>{errors.nextOfKins?.phoneNumber.message}</div>
              )}
            </div>
            {/* Email */}
            <div className='col-md-6 mt-3'>
              <label>Email Address</label>
              <input
                type='email'
                // disabled
                className={`form-control ${errors.nextOfKins?.emailAddress ? 'is-invalid' : ''}`}
                {...register('nextOfKins.emailAddress', {
                  required: 'Email is required',
                })}
              />
              {errors.nextOfKins?.emailAddress && (
                <div className='invalid-feedback'>{errors.nextOfKins?.emailAddress.message}</div>
              )}
            </div>
            {/* Address */}
            <div className='col-md-6 mt-3'>
              <label>Address</label>
              <input
                type='text'
                className={`form-control ${errors.nextOfKins?.address ? 'is-invalid' : ''}`}
                {...register('nextOfKins.address', {
                  required: 'Address is required',
                })}
              />
              {errors.nextOfKins?.address && (
                <div className='invalid-feedback'>{errors.nextOfKins?.address.message}</div>
              )}
            </div>
            <div className='headings mt-4'>EMERGENCY CONTACT</div>
            <div className='col-md-6 mt-3'>
              <label>Full Name</label>
              <input
                type='text'
                className={`form-control ${errors.emergencyContact?.fullName ? 'is-invalid' : ''}`}
                {...register('emergencyContact.fullName', {
                  required: 'Full name is required',
                })}
              />
              {errors.emergencyContact?.fullName && (
                <div className='invalid-feedback'>{errors.emergencyContact?.fullName.message}</div>
              )}
            </div>

            <div className='col-md-6 mt-3'>
              <label htmlFor='emergencyContactRelationship'>Relationship</label>

              <select
                id='emergencyContactRelationship'
                className={`form-control ${errors.emergencyContact?.relationship ? 'is-invalid' : ''}`}
                {...register('emergencyContact.relationship', {
                  required: 'Emergency contact relationship is required',
                })}
              >
                <option value=''>Select relationship</option>

                {relationships.map((rel) => (
                  <option key={rel} value={rel}>
                    {rel}
                  </option>
                ))}
              </select>

              {errors.emergencyContact?.relationship && (
                <div className='invalid-feedback'>
                  {errors.emergencyContact?.relationship.message}
                </div>
              )}
            </div>
            {/* {selectedEmergencyContactRelationship === 'Other' && (
              <div className='col-md-6 mt-3'>
                <label htmlFor='otherEmergencyContactRelationship'>Specify Relationship</label>

                <input
                  type='text'
                  id='otherEmergencyContactRelationship'
                  className={`form-control ${errors.otherEmergencyContactRelationship ? 'is-invalid' : ''}`}
                  {...register('otherEmergencyContactRelationship', {
                    required: 'Please specify the relationship',
                  })}
                />

                {errors.otherEmergencyContactRelationship && (
                  <div className='invalid-feedback'>
                    {errors.otherEmergencyContactRelationship.message}
                  </div>
                )}
              </div>
            )} */}
            {/* Phone */}
            <div className='col-md-6 mt-3'>
              <label htmlFor='emergencyContactPhoneNumber'>Phone Number</label>
              <input
                type='text'
                id='emergencyContactPhoneNumber'
                className={`form-control ${errors.emergencyContact?.phoneNumber ? 'is-invalid' : ''}`}
                {...register('emergencyContact.phoneNumber', {
                  required: 'Emergency contact phone number is required',
                })}
              />
              {errors.emergencyContact?.phoneNumber && (
                <div className='invalid-feedback'>
                  {errors.emergencyContact?.phoneNumber.message}
                </div>
              )}
            </div>
            {/* Email */}
            <div className='col-md-6 mt-3'>
              <label>Email Address</label>
              <input
                type='email'
                // disabled
                className={`form-control ${errors.emergencyContact?.emailAddress ? 'is-invalid' : ''}`}
                {...register('emergencyContact.emailAddress', {
                  required: 'Email is required',
                })}
              />
              {errors.emergencyContact?.emailAddress && (
                <div className='invalid-feedback'>
                  {errors.emergencyContact?.emailAddress.message}
                </div>
              )}
            </div>
            {/* Address */}
            <div className='col-md-6 mt-3'>
              <label>Address</label>
              <input
                type='text'
                className={`form-control ${errors.emergencyContact?.address ? 'is-invalid' : ''}`}
                {...register('emergencyContact.address', {
                  required: 'Address is required',
                })}
              />
              {errors.emergencyContact?.address && (
                <div className='invalid-feedback'>{errors.emergencyContact?.address.message}</div>
              )}
            </div>
          </div>
        </div>
        <div>
          <button className='btn-request' type='submit'>
            Save Changes
            {request2 && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default PersonalInfoUser
